import User from '@/entities/User';

export default class UsersTransformer {
  static transformOne(item) {
    return new User(item);
  }

  static transformList(items) {
    return items.map((e) => UsersTransformer.transformOne(e));
  }
}
